import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/operating-leverage',
  component: () => import('../../routes/OperatingLeverage.svelte'),
  card: {
    id: 'operating-leverage',
    title: 'Operating Leverage',
    description: 'Calculate the Degree of Operating Leverage (DOL) and see how revenue changes amplify operating income. Essential for understanding business risk and leverage.',
    icon: 'account_balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/operating-leverage',
    category: 'Business',
  },
  seo: {
    title: 'Operating Leverage Calculator – Degree of Operating Leverage (DOL)',
    description: 'Free Operating Leverage calculator. Calculate the Degree of Operating Leverage (DOL), contribution margin, and break-even point. Understand how revenue changes amplify operating income for better business planning.',
  },
};

export default meta;